import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LogIn, ShieldAlert } from "lucide-react";
import { getMe } from "../../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [checking, setChecking] = useState(true);
  const unauthorized = params.get("error") === "unauthorized";

  useEffect(() => {
    getMe()
      .then(() => navigate("/admin", { replace: true }))
      .catch(() => setChecking(false));
  }, [navigate]);

  const login = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-foreground/70 font-body">
        Loading…
      </div>
    );
  }

  return (
    <div data-testid="admin-login" className="min-h-screen flex items-center justify-center bg-background px-6">
      <div className="w-full max-w-md bg-secondary border border-border/60 p-10 text-center">
        <div className="flex flex-col leading-none mb-8">
          <span className="font-headings text-3xl tracking-wide text-foreground">Velmira</span>
          <span lang="en" className="brand-caps font-accent text-[11px] uppercase tracking-[0.35em] text-primary -mt-0.5">Living · Admin</span>
        </div>
        <h1 className="font-headings text-2xl text-foreground">Admin Panel</h1>
        <p className="mt-3 font-body font-light text-foreground/70 text-sm">
          Sign in with your authorized Google account to manage leads and properties.
        </p>

        {unauthorized && (
          <div data-testid="admin-login-error" className="mt-6 flex items-start gap-2 border border-primary/40 bg-primary/5 text-primary text-sm p-3 text-left">
            <ShieldAlert size={16} className="shrink-0 mt-0.5" />
            <span>This Google account is not authorized for the admin panel.</span>
          </div>
        )}

        <button
          onClick={login}
          data-testid="admin-google-login"
          className="mt-8 w-full inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-4 uppercase tracking-[0.2em] text-xs font-body transition-all duration-300"
        >
          <LogIn size={16} /> Sign in with Google
        </button>
      </div>
    </div>
  );
}
